// Remove scrolling on input type number
export const removeNumberFieldsScrolling = () => {
  document.addEventListener('wheel', () => {
    if (document.activeElement.type === 'number') {
      document.activeElement.blur();
    }
  });
};
